import { DataRoomType } from "@decentriq/models";
import { memo, useCallback } from "react";
import { DataRoomErrorReportProvider, useApiCore } from "contexts";

type MediaDataRoomV3ErrorReportProps = React.PropsWithChildren<{
  dataRoomId: string;
  createdAt: string;
}>;

const MediaDataRoomV3ErrorReport = memo<MediaDataRoomV3ErrorReportProps>(
  ({ children, dataRoomId, createdAt }) => {
    const { client, getSession, getVerificationKey } = useApiCore();
    const getDcrHLRepresentation = useCallback(async () => {
      const session = await getSession();
      const verificationKey = await getVerificationKey(session);
      const mediaDataRoom = await client.getDataRoom(
        dataRoomId,
        verificationKey
      );
      return JSON.stringify({
        createdAt,
        mediaV3: mediaDataRoom,
      });
    }, [createdAt, getSession, client, dataRoomId, getVerificationKey]);
    const getAuditLog = useCallback(async () => {
      const session = await getSession();
      const verificationKey = await getVerificationKey(session);
      const auditLogs = await client.getDataRoomAuditLog(
        dataRoomId,
        verificationKey
      );
      return auditLogs.logs.map((log) => JSON.stringify(log)).join("\n");
    }, [getSession, client, dataRoomId, getVerificationKey]);
    return (
      <DataRoomErrorReportProvider
        value={{
          dataRoomId,
          dataRoomType: DataRoomType.LookalikeMedia,
          getAuditLog,
          getDcrHLRepresentation,
        }}
      >
        {children}
      </DataRoomErrorReportProvider>
    );
  }
);
MediaDataRoomV3ErrorReport.displayName = "MediaDataRoomV3ErrorReport";

export default MediaDataRoomV3ErrorReport;
